import React from 'react';
import { useTranslation } from 'react-i18next';

function Process() {
  const { t } = useTranslation('homepage');
  const processItems = t('process.items', { returnObjects: true });

  return (
    <section className="tc-process-style1">
      <div className="container">
        <div className="title mb-100 mt-100 text-center">
          <h2 className="fsz-45">
  {t('process.title').split(/(botanicheska 302)/i).map((part, index) =>
    part.toLowerCase() === "botanicheska 302" ? (
      <span key={index} style={{ fontFamily: "TheSeasons", textTransform: "uppercase" }}>
        {part}
      </span>
    ) : (
      part
    )
  )}
</h2>
        </div>
        <div className="content">
          <div className="row">
            <div className="col-lg-5">
              <div className="info">
                <div className="accordion wow fadeInUp slow" id="accordionProcess">

                  {processItems.map((item, index) => (
                    <div key={index} className="accordion-item">
                      <div className="accordion-header" id={`heading${item.number}`}>
                        <button
                          className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${item.number}`}
                        >
                          <span className="num">{item.number} /</span>
                          <h3>{item.title}</h3>
                        </button>
                      </div>
                      <div
                        id={`collapse${item.number}`}
                        className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                        data-bs-parent="#accordionProcess"
                      >
                        <div className="accordion-body">
                          <div className="text">
  {item.description.split(/(botanicheska 302)/i).map((part, index) =>
    part.toLowerCase() === "botanicheska 302" ? (
      <span key={index} style={{ fontFamily: "TheSeasons", textTransform: "uppercase" }}>
        {part}
      </span>
    ) : (
      part
    )
  )}
</div>

                        </div>
                      </div>
                    </div>
                  ))}

                </div>

                <a
                  href="/innerpages/portfolio"
                  className="butn border rounded-pill mt-80"
                  style={{
                    borderColor: 'var(--color-primary)',
                    color: 'var(--color-primary)',
                  }}
                >
                  <span>
                    {t('process.viewProjectButton')}
                    <i className="small ms-1 ti-arrow-top-right"></i>
                  </span>
                </a>
              </div>
            </div>

            <div className="col-lg-4 offset-lg-2">
              <div className="img wow">
                <img
                  src="/home1/assets/img/slider/5.jpg"
                  alt="Проект Botanicheska 302"
                  className="img-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <img src="/home1/assets/img/c_line2.png" alt="" className="c-line wow" />
    </section>
  );
}

export default Process;
